export default "__VITE_ASSET__3f6a730d__"